module.exports = __webpack_public_path__ + "img/ohniste_2.ba53619b.jpg";